import { useQueryClient, useMutation, useQuery } from 'react-query'
import { api } from '../../../utils/api'
import { ICreateTopDealBody, IGetAllTopDealResponse } from './top-deal-type'

export const BASE_TOP_DEAL_URL = 'bo/top-deals'

export const useCreateTopDeal = () => {
  const queryClient = useQueryClient()
  return useMutation<any, string, ICreateTopDealBody>(
    async body => {
      const { data } = await api.savvyGold.post(`${BASE_TOP_DEAL_URL}`, {
        ...body,
      })
      return data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([BASE_TOP_DEAL_URL])
      },
    },
  )
}

export const useUpdateTopDeal = (id: string) => {
  const queryClient = useQueryClient()
  return useMutation<any, string, ICreateTopDealBody>(
    async body => {
      const { data } = await api.savvyGold.put(`${BASE_TOP_DEAL_URL}/${id}`, {
        ...body,
      })
      return data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([BASE_TOP_DEAL_URL])
      },
    },
  )
}

export const useGetTopDeal = (params?: { q?: string; page?: number }) => {
  return useQuery(
    [BASE_TOP_DEAL_URL, params],
    async () => {
      const { data } = await api.savvyGold.get<IGetAllTopDealResponse>(BASE_TOP_DEAL_URL, {
        page: params?.page,
        limit: 100,
        q: params?.q,
        isGetAll: true,
      })
      const result = data.data

      return result
    },
    {
      keepPreviousData: true,
      refetchInterval: 5 * 1000,
    },
  )
}
